// extracted by mini-css-extract-plugin
module.exports = {"girl__chat":"ChatItem_girl__chat__2I22p","my__chat":"ChatItem_my__chat__2Ky8Q","girl__chat_wrap":"ChatItem_girl__chat_wrap__RHHt1","my__chat_wrap":"ChatItem_my__chat_wrap__3TQUh"};